<template>
    <div id="AlertConfigUser">
        <HrrBreadcrumb PMname="报警功能" CMname="报警配置管理" C2Mname="配置人员管理" />
        <HrrDetailLayout>
            <template slot="head">
                报警配置信息：{{title}}
            </template>
            <template slot="Form">
                <el-row :gutter="24">
                    <el-col :span="10">
                        <el-input placeholder="输入关键字查找信息" v-model="filterText"></el-input>
                    </el-col>
                    <el-col :span="14">
                        <el-button type="primary" @click="Treeexpand(true)">全部展开</el-button>
                        <el-button type="info" @click="Treeexpand(false)">全部收起</el-button>
                    </el-col>
                </el-row>
                <br />
                <el-row :gutter="24">
                    <el-col :span="10">
                        <el-tree 
                        show-checkbox 
                        :data="treeData" 
                        :props="defaultProps" 
                        node-key="aId" 
                        highlight-current 
                        :filter-node-method="filterNode" 
                        :default-expand-all="defaultexpandall" 
                        ref="FunTree" 
                        v-loading="loading">
                        </el-tree>
                    </el-col>
                    <el-col :span="14">
                    </el-col>
                </el-row>
            </template>
            <template slot="buttons">
                <el-button type="primary" @click="submitMForm">提 交</el-button>
                <el-button @click="clearMForm">清 空</el-button>
                <el-button type="info" @click="returnMForm()">返 回</el-button>
            </template>
        </HrrDetailLayout>
    </div>
</template>
<script>
export default {
    name: 'Config_user',
    watch: {
        filterText(val) {
            this.filterArr.length = 0;
            this.$refs.FunTree.filter(val);
        }
    },
    data() {
        return {
            defaultexpandall: false,
            filterText: "",
            filterArr: [],
            treeData: [],
            mytreeData: [],
            defaultProps: {
                children: 'childList',
                label: 'aName'
            },
            title: "",
            loading: true
        }
    },
    methods: {
        Treeexpand(val) {
            for (var i = 0; i < this.$refs.FunTree.store._getAllNodes().length; i++) {
                this.$refs.FunTree.store._getAllNodes()[i].expanded = val;
            }
        },
        filterNode(value, data, node) {
            if (!value) {
                delete data.filter;
                return true;
            }
            if (data.aName.indexOf(value) !== -1) {
                this.filterArr.push(data.aId.toString());
                data.filter = true;
                return true;
            }
            if (data.aId.toString().indexOf('-') !== -1) {
                var m_id = data.aId.split("-")[1];
                var re = this.filterArr.indexOf(m_id) !== -1;
                data.filter = re;
                return re;
            }
            return false;
        },
        submitMForm: function() {
            var selectnodes = this.$refs.FunTree.getCheckedNodes(true);
            if (selectnodes.length < 1) {
                this.$message({ message: "请先选择功能在操作", type: "warning" });
                return;
            }
            var loading = this.$loading({
                lock: true,
                text: '提交中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var Vuethis = this;
            var form = { aConfigId: parseInt(this.$route.params.id) };
            form.addAlertUsers = [];
            selectnodes.forEach(function(element, index) {
                var userId = parseInt(element.aId.split('-')[0]);
                var deviceCode = element.aId.split('-')[1];
                if (element.filter != undefined) {
                    if (element.filter) {
                        form.addAlertUsers.push({ userId: userId, deviceCode: deviceCode })
                    }
                } else {
                    form.addAlertUsers.push({ userId: userId, deviceCode: deviceCode })
                }
            });
            this.$hrraxios.post(this.$api.AlertUser.api, form)
                .then(function(response) {
                    loading.close();
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.$alert("提交成功！", {
                            callback: action => {
                                Vuethis.$router.push({ path: '/alert/config' });
                            }
                        });
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                }).catch(function(error) {
                    loading.close();
                    console.log(error);
                })
        },
        clearMForm: function() {
            this.$refs.FunTree.setCheckedKeys([]);
        },
        returnMForm: function() {
            this.$router.go(-1);
        },
        initData: function() {
            var row = this.$route.meta.row;
            this.title = row.alertName + "(当" + row.mtypeName + row.alertCondition + row.alertValue + ")" + "发送" + row.alertType;
            this.loading = true;
            var Vuethis = this;
            this.$hrraxios.get(this.$api.AlertUser.Tree)
                .then((response) => {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.treeData = data.Data;
                        Vuethis.initSelectedData();
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch((error) => {
                    Vuethis.loading = false;
                })
        },
        initSelectedData() {
            var aConfigId = this.$route.params.id;
            var Vuethis = this;
            this.$hrraxios.get(this.$api.AlertUser.ByConfigId + "/" + aConfigId)
                .then((response) => {
                    var redata = response.data;
                    if (redata.Success == true) {
                        Vuethis.mytreeData = redata.Data;
                        Vuethis.$refs.FunTree.setCheckedNodes(Vuethis.mytreeData);
                    } else {
                        Vuethis.$message.error(redata.Prompt);
                    }
                })
                .catch((error) => {
                    console.log(error);
                })

        }

    },
    created: function() {
        this.initData();
    }
}
</script>
<style>
.el-form-module {
    width: 500px;
}
</style>